import { FunctionalComponent } from 'preact'
import classnames from 'classnames'

export interface CategoryListItemProps extends JSX.HTMLAttributes {
  label: string
  count: number
  active: boolean
}

export const CategoryListItem: FunctionalComponent<CategoryListItemProps> = ({
  label,
  count,
  active,
  className,
  ...restProps
}) => (
  <li role='button' className={classnames(className, { active })} {...restProps}>
    {label}
    <span className='counter'>{count}</span>
  </li>
)
